/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonAddressViewModel } from "../types/PersonAddressViewModel.ts";
import { eAddressTypeSchema } from "./eAddressTypeSchema.ts";

export const personAddressViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  addressId: z.optional(z.number().int()),
  type: z.optional(
    z
      .lazy(() => eAddressTypeSchema)
      .describe("1 = Personal | 2 = Commercial | 3 = Payment | "),
  ),
  street: z.string().nullish(),
  zipCode: z.string().nullish(),
  placeNumber: z.string().nullish(),
  neighborhood: z.string().nullish(),
  complement: z.string().nullish(),
  countryId: z.optional(z.number().int()),
  stateId: z.number().int().nullish(),
  cityId: z.number().int().nullish(),
  stateName: z.string().nullish(),
  cityName: z.string().nullish(),
}) as unknown as ToZod<PersonAddressViewModel>;
